var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccessibilityLogo = function SvgAccessibilityLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 25"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.91,
    cy: 3.738,
    r: 3,
    stroke: "#000",
    strokeWidth: 0.75,
    vectorEffect: "non-scaling-stroke"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.75,
    d: "M6.798 7.282H2.731C1.775 7.282 1 8.026 1 8.944s.775 1.662 1.731 1.662H7.05c2.016-.097 1.616.837 1.02 2.354L4.5 22.06c-.335.855.12 1.799 1.016 2.105.893.306 1.884-.138 2.214-.991l3.252-8.403a.1.1 0 0 1 .096-.063c.042 0 .08.025.095.063l3.252 8.403c.33.853 1.321 1.297 2.214.991.896-.306 1.352-1.25 1.016-2.105l-3.588-9.146c-.374-.953-1.186-2.309.49-2.309h4.533c.956 0 1.73-.744 1.73-1.662s-.774-1.662-1.73-1.662h-4.198",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgAccessibilityLogo;